module.exports = __webpack_public_path__ + "static/media/surpriseMeImage.c40a7ece.svg";